import { Id } from 'Common/Id';
import {AccessArea} from 'Common/permissions/AccessArea';
import {Role} from 'Common/permissions/Role';

export class AdminRole extends Role
{
	constructor()
	{
		super('admin');
	}

	public toJson()
	{
		return {
			type: this.name
		};
	}

	public topAccess(): AccessArea
	{
		return new AccessArea('admin');
	}

	public canAccessArea(_area:AccessArea)
	{
		return true;
	}

	public amManager(_artistId: Id)
	{
		return true;
	}
}

